<template>
  <div class="to-do-list">
    <h1>List your task. It's easy</h1>
    <form @submit.prevent="submitTask">
      <label for="">New task</label>
      <input type="text" v-model="task" />
      <p
        v-if="errorMessage"
        style="color: crimson; margin-top: -5px; font-size: smaller"
      >
        {{ errorMessage }}
      </p>
      <button type="submit">Add</button>
    </form>

    <div v-if="tasks.length != 0" class="task-list">
      <p>Your task list</p>
      <ul>
        <li v-for="task in tasks" :key="task.id">
          <div class="item" style="width: 70%; word-wrap: break-word">
            <p style="">{{ task.name }}</p>
            <p style="font-size: x-small; margin: 5px 0px">
              {{ task.time }}
            </p>
          </div>

          <span class="item" @click="deleteTask(task.id)">Done</span>
        </li>
      </ul>
    </div>
  </div>

  <div class="social-media-container">
    <p>Made with ❤️ by Andrian Putra Ramadan</p>
    <div>
      <a href="https://www.instagram.com/andrian_r7/">Instagram</a>
      <a href="https://github.com/andrian2929">Github</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      task: null,
      errorMessage: null,
      tasks: JSON.parse(localStorage.getItem("tasks")) || [],
    };
  },

  methods: {
    submitTask() {
      console.log(this.tasks);
      if (this.task) {
        // Add task to array of tasks
        this.tasks.push({
          id: `${Date.now()}${Math.random().toString().replace(".", "")}}`,
          name: this.task,
          isFinished: false,
          time: new Date().toLocaleString("en-US"),
        });

        // Save array of tasks to local storage
        localStorage.setItem("tasks", JSON.stringify(this.tasks));
        this.task = null;
        this.tasks = JSON.parse(localStorage.getItem("tasks"));
        this.errorMessage = null;
      } else {
        this.errorMessage = "Task cannot be empty";
      }
    },
    deleteTask(id) {
      this.tasks = this.tasks.filter((task) => task.id !== id);
      localStorage.setItem("tasks", JSON.stringify(this.tasks));
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@500;600;700&display=swap");
.to-do-list > h1 {
  margin-top: 50px;
}
.to-do-list {
  font-family: "Inter", sans-serif;
  max-width: 425px;
  background-color: #1b2430;
  padding: 10px 30px;
  margin: 0 auto;
  border-radius: 40px;

  color: white;
}

.to-do-list > form {
  margin-top: 50px;
  width: 100%;
  margin-bottom: 50px;
}

.to-do-list > form > label {
  display: block;
  margin-bottom: 10px;
}

.to-do-list > form > input[type="text"] {
  font-family: "Inter", sans-serif;
  width: 80%;
  height: 35px;
  padding: 0px 10px;
  border: none;
  border-radius: none;
  margin-bottom: 20px;
}

.to-do-list > form > input[type="text"]:focus {
  outline: none;
}

.to-do-list > form > button {
  color: white;
  font-family: "Inter", sans-serif;
  width: 65px;
  height: 35px;
  padding: 0px 10px;
  border: none;
  border-radius: none;
  margin-bottom: 20px;
  background-color: #51557e;
  display: block;
}

.to-do-list > form > button:hover {
  background-color: #2c3e50;
}

.task-list > ul {
  list-style: none;
  padding: 0;
}

.task-list > ul > li {
  margin: 20px 0;
  background-color: #816797;
  padding: 15px;
  border-radius: 5px;
  display: flex;
  align-items: center;
}

.task-list > ul > li > span {
  padding: 5px 10px;
  background-color: #2c3e50;

  font-size: smaller;
  cursor: pointer;
  border-radius: 3px;
  margin-left: auto;
}

.task-list > ul > li > span:hover {
  background-color: #51557e;
}

.social-media-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.social-media-container > div {
  margin: 25px 0px;
}

.social-media-container > div > a {
  color: white;
  font-family: "Inter", sans-serif;

  padding: 10px 10px;
  border: none;
  border-radius: none;
  background-color: #51557e;
  text-decoration: none;
  font-size: smaller;
  margin: 0px 10px;
}
.social-media-container > p {
  color: white;
  font-family: "Inter", sans-serif;

  margin: 0px 10px;
}
</style>
